module.exports = __webpack_public_path__ + "img/商城东莞联通流量卡.6bc284e7.png";